import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/flags/US.svg")